module.exports = __webpack_public_path__ + "img/s3-2.911b53e4.svg";